import React, { useState } from 'react';
import { useCalibrationState } from '../context/CalibrationPageContext';
import {
  Box,
  CircularProgress,
  Stack,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';

import AddCalibrations from '../calibration_page_components/AddCalibrations';
import UpdateTestBoxes from '../calibration_page_components/UpdateTestBoxes';


function CalibrationsPage() {
  const { dataLoading, dataError } = useCalibrationState();

  const [activeTab, setActiveTab] = useState(0);

  return (
    <Box height={{ xs: 'auto', md: '100%' }}>
      <Stack
        direction='row'
        alignItems='center'
        justifyContent='space-between'
        sx={{ mb: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Tabs
          value={activeTab}
          onChange={(_, v) => { setActiveTab(v) }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{ '& .MuiTab-root': { minWidth: 'auto' } }}
        >
          <Tab label='Sensor Calibrations' sx={{ py: 1, fontWeight: 600, fontSize: { xs: '0.85rem', sm: '1rem' } }} />
          <Tab label='Test Box Sensors' sx={{ py: 1, fontWeight: 600, fontSize: { xs: '0.85rem', sm: '1rem' } }} />
        </Tabs>

        <Stack direction='row' alignItems='center' spacing={1} sx={{ pr: 1 }}>
          {dataError && (
            <Typography variant='caption' color='error.main'>{dataError}</Typography>
          )}
          {dataLoading && <CircularProgress size={16} />}
        </Stack>
      </Stack>

      {/* Main Content Area */}
      <Box height={{ xs: 'auto', md: 'calc(100% - 56px)' }}>
        {activeTab === 0 && (
          <AddCalibrations />
        )}
        {activeTab === 1 && (
          <UpdateTestBoxes />
        )}
      </Box>

    </Box>
  );
}

export default CalibrationsPage;
